module.exports = __webpack_public_path__ + "6c00601730f89c6a94fc5af69e6b43fe.ttf";